import React from 'react'
import { ThemeProvider } from 'styled-components'
import borders from './borders'
import breakpoint from './breakpoint'
import color from './color'
import font from './font'
import GlobalStyle from './global'
import media from './media'
import opacity from './opacity'
import size from './size'
import space from './space'
import zindex from './zindex'

export const tokens = {
  breakpoint,
  color,
  font,
  space,
  media,
  borders,
  opacity,
  zindex,
  size
}

const Provider = ({ theme = tokens, children }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    {children}
  </ThemeProvider>
)

export default Provider
